import { render, staticRenderFns } from "./MediaCode.vue?vue&type=template&id=424eb1a7&scoped=true&"
import script from "./MediaCode.vue?vue&type=script&lang=js&"
export * from "./MediaCode.vue?vue&type=script&lang=js&"
import style0 from "./MediaCode.vue?vue&type=style&index=0&id=424eb1a7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424eb1a7",
  null
  
)

export default component.exports